/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.2.0. DO NOT EDIT. DO NOT COMMIT.

import StringMetricType from '@mozilla/glean/private/metrics/string';

/**
 * one of 'mobile', 'tablet', or 'desktop'
 *
 * Generated from `session.device_type`.
 */
export const deviceType = new StringMetricType({
  category: 'session',
  name: 'device_type',
  sendInPings: ['accounts-events', 'events'],
  lifetime: 'application',
  disabled: false,
});

/**
 * entrypoint to the service
 *
 * Generated from `session.entrypoint`.
 */
export const entrypoint = new StringMetricType({
  category: 'session',
  name: 'entrypoint',
  sendInPings: ['accounts-events', 'events'],
  lifetime: 'application',
  disabled: false,
});

/**
 * an ID generated by FxA for its flow metrics
 *
 * Generated from `session.flow_id`.
 */
export const flowId = new StringMetricType({
  category: 'session',
  name: 'flow_id',
  sendInPings: ['accounts-events', 'events'],
  lifetime: 'application',
  disabled: false,
});

/**
 * A SHA-256 hash of the device pairing channel id, hex encoded. The two
 * devices in a pairing are separate sessions with separate flow ids, so this
 * is what joins the desktop and mobile halves of one pairing into a single
 * funnel. Empty outside a pairing flow. Hashed because the raw channel id
 * addresses a live channel; the hash is one-way and the id is a random
 * 32-character value, so it cannot be reversed by search.
 *
 * Generated from `session.pairing_channel_hash`.
 */
export const pairingChannelHash = new StringMetricType({
  category: 'session',
  name: 'pairing_channel_hash',
  sendInPings: ['accounts-events', 'events'],
  lifetime: 'application',
  disabled: false,
});
